class CartGift extends HTMLElement {
  constructor() {
    super();
    this._processing = false;
  }

  connectedCallback() {
    this.cartModal = document.querySelector("cart-modal");
    this.sectionId = this.cartModal.getAttribute("data-section-id");
    this.gift1Threshold = parseFloat(this.getAttribute("data-gift-1-threshold"));
    this.gift1VariantId = this.getAttribute("data-gift-1-variant-id");
    this.gift2Threshold = parseFloat(this.getAttribute("data-gift-2-threshold"));
    this.gift2VariantId = this.getAttribute("data-gift-2-variant-id");

    this.checkGiftProducts();
  }

  async addProductToCart(variantId) {
    // FIX: idempotente — si ya existe en cart, fuerza qty: 1; si no, agrega.
    const cart = await fetch('/cart.js').then(r => r.json());
    const variantIdNum = parseInt(variantId);
    const existing = cart.items.find(i => i.variant_id === variantIdNum);

    if (existing) {
      // Ya existe — fuerza qty a 1 (no incrementar)
      if (existing.quantity !== 1) {
        await this.changeProductQty(existing.key, 1);
      }
      return;
    }

    // No existe — agregar fresh
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: { _freeGift: true }
          }
        ],
        sections: [this.sectionId, "cart-bubble"],
        sections_url: window.location.pathname
      }),
    });
    const data = await response.json();
    await this.updateCart(data);
  }

  async changeProductQty(key, qty) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        sections: [this.sectionId, "cart-bubble"],
        sections_url: window.location.pathname
      }),
    });
    const data = await response.json();
    await this.updateCart(data);
  }

  async removeProductFromCart(key) {
    return this.changeProductQty(key, 0);
  }

  async updateCart(data) {
    this.cartModal.updateFromSectionHtml(data.sections[this.sectionId]);
    document.dispatchEvent(new CustomEvent("cart-bubble-ajax-init", {
      detail: {
        i: data.sections["cart-bubble"].match(/\d+/)
      }
    }));
  }

  async checkGiftProducts() {
    // FIX: lock para evitar concurrent runs
    if (this._processing) return;
    this._processing = true;

    try {
      const currentCartTotal = parseFloat(this.getAttribute("data-cart-total"));

      const hasAzulCoupon = document.cookie.includes('cupom_azul=true');
      const guaShaId = "49583839314232"; // ⚠️ ID de Gua Sha regalo
      const skipGift2Removal = hasAzulCoupon && this.gift2VariantId === guaShaId;

      // FIX: usar cart.js como fuente de verdad (no atributos DOM stale)
      const cart = await fetch('/cart.js').then(r => r.json());

      // ===== Regalo 1 =====
      if (this.gift1VariantId) {
        const gift1VarId = parseInt(this.gift1VariantId);
        const gift1InCart = cart.items.find(i => i.variant_id === gift1VarId);

        if (currentCartTotal >= this.gift1Threshold) {
          if (!gift1InCart) {
            await this.addProductToCart(this.gift1VariantId);
          } else if (gift1InCart.quantity !== 1) {
            // FIX: existe pero con qty > 1 → forzar a 1
            await this.changeProductQty(gift1InCart.key, 1);
          }
        } else {
          if (gift1InCart) {
            await this.removeProductFromCart(gift1InCart.key);
          }
        }
      }

      // ===== Regalo 2 (Gua Sha) =====
      if (this.gift2VariantId) {
        const gift2VarId = parseInt(this.gift2VariantId);
        const gift2InCart = cart.items.find(i => i.variant_id === gift2VarId);

        if (currentCartTotal >= this.gift2Threshold) {
          if (!gift2InCart) {
            await this.addProductToCart(this.gift2VariantId);
          } else if (gift2InCart.quantity !== 1) {
            await this.changeProductQty(gift2InCart.key, 1);
          }
        } else {
          if (gift2InCart && !skipGift2Removal) {
            await this.removeProductFromCart(gift2InCart.key);
          } else if (gift2InCart && skipGift2Removal && gift2InCart.quantity !== 1) {
            // Cupón azul mantiene el gift, pero igual forzar qty=1
            await this.changeProductQty(gift2InCart.key, 1);
          }
        }
      }
    } finally {
      this._processing = false;
    }
  }
}

customElements.define("cart-gift", CartGift);